var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { continuationErrorMessage } from "../constants/FeatureDataConstants.js";
import { onError } from "@ane/core/lib/decorators/OnError";
import { expAdapterService } from "../services/middlewares/ExpAdapterMiddleware.js";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ExperimentReadV2Resource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/api/2.0/experiments/");
  }
  getRolloutRootStepId(rolloutId) {
    return __async(this, null, function* () {
      const address = `${rolloutId}`;
      const result = yield this._get(address);
      const experiment = result.getSuccessData();
      return experiment.Stages[0].ParallelSteps[0].Id;
    });
  }
  getExperiment(id) {
    return __async(this, null, function* () {
      const address = `${id}`;
      const result = yield this._get(address);
      return result;
    });
  }
};
__decorateClass([
  onError({ message: `An error occurred while getting the rollout root's stepId. ${continuationErrorMessage}` })
], ExperimentReadV2Resource.prototype, "getRolloutRootStepId", 1);
__decorateClass([
  onError({ message: `An error occurred while getting the experiment. ${continuationErrorMessage}` })
], ExperimentReadV2Resource.prototype, "getExperiment", 1);
ExperimentReadV2Resource = __decorateClass([
  WPSProxyConverter(),
  expAdapterService()
], ExperimentReadV2Resource);
const experimentResource = new ExperimentReadV2Resource();
export {
  ExperimentReadV2Resource,
  experimentResource as default
};
//# sourceMappingURL=ExperimentReadV2Resource.js.map
